
import { commonModalTypes } from './commonModalTypes';

export const commonModalConfig = [
    {
        modalType: commonModalTypes.ADDED_TO_BOB_MODAL,
        modalId: 'added-to-BOB__modal',
        modalHeaderTextData: 'selfDesignation.search.becomeAOR.modal.success.header'
    },
    {
        modalType: commonModalTypes.BECOME_AOR_MODAL,
        modalId: 'become__AOR__modal',
        modalHeaderTextData: 'selfDesignation.search.becomeAOR.modal.accept.header'
    },
    {
        modalType: commonModalTypes.SELF_DESIGNATION_OTP_MODAL,
        modalId: 'self-designation-otp-modal',
        modalHeaderTextData: 'selfDesignation.search.searchResult.modal.otp.header',
        bodyId: 'self-designation-otp-modal-body'
    },
    {
        modalType: commonModalTypes.SELF_DESIGNATION_OTP_ERROR_MODAL,
        modalId: 'self-designation-otp-error-modal',
        modalHeaderTextData: 'selfDesignation.search.searchResult.modal.otp.header',
        bodyId: 'self-designation-otp-modal-body'
    },
    {
        modalType: commonModalTypes.SEARCH_RESULT_MODAL,
        modalId: 'search__result__modal',
        modalHeaderTextData: 'selfDesignation.search.becomeAOR.modal.accept.header'
    },
    {
        modalType: commonModalTypes.LOCATE_ASSISTANCE_MODAL,
        modalId: 'locate-assistance-modal',
        modalHeaderTextData: null,
        bodyId: 'locateAssistanceModal'
    },
    {
        modalType: commonModalTypes.SAVE_RESULT_MODAL,
        modalId: 'save-result-modal',
        modalHeaderTextData: null,
        bodyId: 'save-result-modal'
    },
    {
        modalType: commonModalTypes.SESSION_IDLE_WARNING_MODAL,
        modalId: 'session__idle-warning__modal',
        modalHeaderTextData: 'modals.header.session_timeout',
        role: 'alertdialog'
    },
    {
        modalType: commonModalTypes.APP_IN_PROGRESS,
        modalId: 'app-in-progress__modal',
        modalHeaderTextData: 'app_in_progress_modal_header'
    },
    {
        modalType: commonModalTypes.REQUEST_ERROR,
        modalId: 'request-error-modal',
        modalHeaderTextData: 'modals.header.request_error'
    },
    {
        modalType: commonModalTypes.UPLOAD_MODAL,
        modalId: 'file-upload-modal',
        modalHeaderTextData: 'modals.header.file_upload'
    },
    {
        modalType: commonModalTypes.RESUBMIT_MODAL,
        modalId: 'resubmit-documents-modal',
        modalHeaderTextData: 'modals.header.resubmit_documents'
    },
    {
        modalType: commonModalTypes.VIEW_IMAGE_MODAL,
        modalId: 'view-image-modal',
        modalHeaderTextData: null
    },
    {
        modalType: commonModalTypes.ADMIN_PLANS_DRUGS_COMMON_MODAL,
        modalId: 'admin-plans-drugs-common-modal',
        modalHeaderTextData: null,
        bodyId: 'self-designation-otp-modal-body'
    },
];
